module.exports = __webpack_public_path__ + "media/warranty-claim/vent-success-2574550b.svg";